<div class="modal-header">
	<h4 class="modal-title">Layer</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
	<!-- <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
		<div class="input-group">
			<button *ngFor="let a of attachments" class="btn btn-outline-secondary" (click)="null" role="button">{{a}}
				<bi name="x" (click)="ns.command(C.removeAttachment).emit(a)"></bi>
			</button>
		</div>
		<div class="btn-group mr-2" role="group">
			<button id="btnGroupAddon" class="btn btn-outline-secondary" (click)="onAddAttachment()" role="button">
				<bi name="paperclip"></bi>&nbsp;Geodaten laden
			</button>
		</div>
		<input style="display: none" type="file" onclick="value = null" (change)="onFileAdded($event)" #attachmentFileInput>
	</div> -->

	<input style="display: none" type="file" onclick="this.value = null" (change)="onFileAdded($event)" accept=".gpkg,.tif,.tiff,.geojson,.json,.shp,.dbf,.prj,.shx,.zip,.7z" multiple #attachmentFileInput>

	<div class="accordion">
		<div class="accordion-item">
			<h2 class="accordion-header">
				<div class="accordion-button">
					<button type="button" class="btn btn-outline-dark" title="Geodaten hinzufügen" (click)="onAddAttachment()">
						<i class="bi bi-plus-lg"></i>
					</button>
					<span>Geodaten-Dateien</span>
				</div>
			</h2>
			<div class="accordion-body">
				@if (missingGeodataFiles().length > 0) {
					<div class="alert alert-warning py-2 mb-2">
						<strong>Fehlende Geodatendateien:</strong>
						<ul class="mb-0 ps-3 list-unstyled">
							@for (file of missingGeodataFiles(); track file) {
								<li class="d-flex align-items-center gap-2 py-1">
									<button class="btn btn-sm btn-outline-danger p-1"
											(click)="onRestoreMissingFile(file)"
											title="Datei suchen">
										<i class="bi bi-folder-x"></i>
									</button>
									<small class="text-truncate">{{ file }}</small>
								</li>
							}
						</ul>
						<small class="text-muted">Klicken Sie auf das Icon um die Datei zu suchen.</small>
					</div>
				}
				@if (attachments().length === 0 && missingGeodataFiles().length === 0) {
					<p class="text-muted mb-0">Keine Geodaten-Dateien verwendet. Klicken Sie auf <i class="bi bi-plus-lg"></i> um Dateien hinzuzufügen.</p>
				}
				<bp-checkbox-tree [nodes]="attachments()" [loadChildren]="onLoadChildrenForAttachmentNode.bind(this)" (selectionChange)="onAttachmentSelectionChange($event)" [showDelete]="true" (deleteNode)="onDeleteAttachment($event)" [showStyle]="true" (styleNode)="onOpenGpkgStyleModal($event)" (styleParentNode)="onOpenGeoJsonStyleModal($event)"></bp-checkbox-tree>
			</div>
		</div>
		<div class="accordion-item">
			<h2 class="accordion-header">
				<div class="accordion-button">
					<button type="button" class="btn"
							[class.btn-outline-dark]="!editModeWms()"
							[class.btn-dark]="editModeWms()"
							title="Alle WMS-Dienste anzeigen"
							[disabled]="oms.offlineMode()"
							(click)="editModeWms.set(!editModeWms())">
						<i class="bi bi-pencil"></i>
					</button>
					<span>WMS-Services</span>
					@if (oms.offlineMode()) {
						<small class="text-muted ms-2">(Im Offline-Modus nicht verfügbar)</small>
					}
				</div>
			</h2>
			<div class="accordion-body">
				@if (displayedWmsLayers().length === 0 && !editModeWms()) {
					<p class="text-muted mb-0">Keine WMS-Services verwendet. Klicken Sie auf <i class="bi bi-pencil"></i> um Services hinzuzufügen.</p>
				}
				<bp-checkbox-tree [nodes]="displayedWmsLayers()" [loadChildren]="onLoadChildrenForWmsServiceNode.bind(this)" (selectionChange)="onLayerSelectionChange($event)" [disabled]="oms.offlineMode()"></bp-checkbox-tree>
			</div>
		</div>

		<!-- Punktraster -->
		<div class="accordion-item">
			<h2 class="accordion-header">
				<div class="accordion-button">
					<button type="button" class="btn"
							[class.btn-outline-dark]="!gridEnabled()"
							[class.btn-dark]="gridEnabled()"
							title="Punktraster aktivieren/deaktivieren"
							(click)="toggleGrid()">
						<i class="bi bi-grid-3x3"></i>
					</button>
					<span>Punktraster</span>
				</div>
			</h2>
			<div class="accordion-body">
				<bp-grid-controls
					[gridEnabled]="gridEnabled()"
					[gridResolution]="gridResolution()"
					[gridRadius]="gridRadius()"
					[gridStyle]="gridStyle()"
					(enabledChange)="onGridEnabledChange($event)"
					(resolutionChange)="onGridResolutionChange($event.toString())"
					(radiusChange)="onGridRadiusChange($event.toString())"
					(styleChange)="onGridStyleChange($event)">
				</bp-grid-controls>
			</div>
		</div>

		<!-- Zeichnungslayer -->
		<div class="accordion-item">
			<h2 class="accordion-header">
				<div class="accordion-button">
					<button type="button" class="btn btn-outline-dark"
							title="Zeichnungslayer hinzufügen"
							(click)="addZeichnungslayer()">
						<i class="bi bi-plus-lg"></i>
					</button>
					<span>Zeichnungslayer</span>
				</div>
			</h2>
			<div class="accordion-body">
				@if (zeichnungslayer().length === 0) {
					<p class="text-muted mb-0">Keine Zeichnungslayer vorhanden. Klicken Sie auf <i class="bi bi-plus-lg"></i> um einen hinzuzufügen.</p>
				}
				@for (layer of zeichnungslayer(); track layer.id) {
					<div class="d-flex align-items-center gap-2 py-1">
						<input class="form-control form-control-sm flex-grow-1"
							   [value]="layer.name"
							   (blur)="renameZeichnungslayer(layer.id, $any($event.target).value)">
						<span class="color-indicator clickable"
							  [style.background-color]="getFillColor(layer)"
							  [style.border-color]="getStrokeColor(layer)"
							  (click)="openStyleModal(layer)"
							  title="Zeichenstil ändern"></span>
						<button class="btn btn-sm btn-outline-dark"
								(click)="zoomToZeichnungslayer(layer.id)"
								title="Auf Layer zoomen">
							<i class="bi bi-search"></i>
						</button>
						<button class="btn btn-sm btn-outline-danger"
								(click)="deleteZeichnungslayer(layer.id)"
								title="Löschen">
							<i class="bi bi-trash"></i>
						</button>
					</div>
				}
			</div>
		</div>
	</div>
</div>

<div class="modal-footer">
	<button ngbAutofocus type="button" class="btn btn-outline-secondary" (click)="onClose()">OK</button>
</div>
